import React from "react";
import { Button, Icon, LinkButton } from "./styles";
import { BOOK_A_DEMO_URL } from "../../../lib/constants";

function MainButton({
  data = { title: "Book a Demo" },
  formatLinkHref,
  handleClickNavLink,
  variant = "header",
}) {
  const buttonInner = (
    <>
      {data.title}
      <Icon
        src="/images/icons/arrow-top-right-white.svg"
        alt="Arrow icon"
        $variant={variant}
      />
    </>
  );

  if (!data.onClick) {
    return (
      <LinkButton
        href={formatLinkHref({
          href: BOOK_A_DEMO_URL,
        })}
        onClick={handleClickNavLink}
        $variant={variant}
      >
        {buttonInner}
      </LinkButton>
    );
  }

  return (
    <Button
      onClick={(e) => {
        data.onClick();
        handleClickNavLink(e);
      }}
      $variant={variant}
    >
      {buttonInner}
    </Button>
  );
}

export default MainButton;
